var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVehicleNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5295 1.47383C20.2807 0.740096 19.5843 0.217773 18.7635 0.217773H5.08364C4.26285 0.217773 3.57886 0.740096 3.3177 1.47383L0.730957 8.92314V18.8721C0.730957 19.5561 1.29059 20.1158 1.97458 20.1158H3.21821C3.9022 20.1158 4.46183 19.5561 4.46183 18.8721V17.6285H19.3853V18.8721C19.3853 19.5561 19.945 20.1158 20.6289 20.1158H21.8726C22.5566 20.1158 23.1162 19.5561 23.1162 18.8721V8.92314L20.5295 1.47383ZM5.08364 13.8976C4.05143 13.8976 3.21821 13.0644 3.21821 12.0322C3.21821 11 4.05143 10.1668 5.08364 10.1668C6.11585 10.1668 6.94908 11 6.94908 12.0322C6.94908 13.0644 6.11585 13.8976 5.08364 13.8976ZM18.7635 13.8976C17.7313 13.8976 16.8981 13.0644 16.8981 12.0322C16.8981 11 17.7313 10.1668 18.7635 10.1668C19.7957 10.1668 20.6289 11 20.6289 12.0322C20.6289 13.0644 19.7957 13.8976 18.7635 13.8976ZM3.21821 7.67952L5.08364 2.08321H18.7635L20.6289 7.67952H3.21821Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleNumber);
export default __webpack_public_path__ + "static/media/vehicle_number.8523e2d4ac92fed25bafab4e473534fc.svg";
export { ForwardRef as ReactComponent };